import { useEffect } from 'react';
import { io, Socket } from 'socket.io-client';
import { getEnv } from '../services/env-service';
import urlJoin from 'url-join';
import { useSelector } from 'react-redux';
import { getIsUserLoggedIn } from 'store/selectors/auth';
import { getUserToken } from 'services/token';

export const SOCKET_NAME = {
  ACG_PHASE_1: 'acg-phase-1',
  ACG_PHASE_2: 'acg-phase-2',
};

const sockets = {
  [SOCKET_NAME.ACG_PHASE_1]: io(
    urlJoin(getEnv('REACT_APP_ACG_BASE_URL').replace('http', 'ws')),
    {
      transports: ['websocket'],
      autoConnect: false,
      path: '/phase-1/socket',
      auth: cb => cb({ token: getUserToken() }),
    },
  ),
  [SOCKET_NAME.ACG_PHASE_2]: io(
    urlJoin(getEnv('REACT_APP_ACG_BASE_URL').replace('http', 'ws')),
    {
      transports: ['websocket'],
      autoConnect: false,
      path: '/phase-2/socket',
      auth: cb => cb({ token: getUserToken() }),
    },
  ),
};

export const SOCKET_EVENTS = {
  ACG_PHASE_1: {
    CAMPAIGN_GENERATION_JOB_CREATED: 'CAMPAIGN_GENERATION_JOB_CREATED',
    CAMPAIGN_GENERATION_JOB_UPDATED: 'CAMPAIGN_GENERATION_JOB_UPDATED',
    BQ_ROUTINES_SYNC_STATUS_UPDATED: 'BQ_ROUTINES_SYNC_STATUS_UPDATED',
    EXCLUSION_JOB_CREATED: 'EXCLUSION_JOB_CREATED',
    EXCLUSION_JOB_UPDATED: 'EXCLUSION_JOB_UPDATED',
    EXCLUSION_JOB_EXCLUSION_FILE_UPDATED:
      'EXCLUSION_JOB_EXCLUSION_FILE_UPDATED',
    EXCLUSION_JOB_CAMPAIGN_FILE_UPDATED: 'EXCLUSION_JOB_CAMPAIGN_FILE_UPDATED',
  },
  ACG_PHASE_2: {
    MASTER_CSV_CREATED: 'MASTER_CSV_CREATED',
    MASTER_CSV_UPDATED: 'MASTER_CSV_UPDATED',
    PLANNING_CSV_UPDATED: 'PLANNING_CSV_UPDATED',
  },
};

export function useSocket(name): Socket {
  const socket = sockets[name];
  if (!socket) throw new Error(`Socket ${name} not found`);
  const isLoggedIn = useSelector(getIsUserLoggedIn);
  useEffect(() => {
    if (isLoggedIn && !socket.connected) {
      socket.connect();
    }
    return () => {
      socket.disconnect();
    };
  }, [isLoggedIn]);
  return sockets[name];
}
